/**
 * 「这条广告的对话」 from another page (经营's ad list, say): 对话 opens on that ad's chats, or one product's, with
 * nothing else narrowing them — the search, the work list and the rest of 筛选 are let go, both networks shown, so
 * the count on the list is that ad's whole count.
 *
 *   import { showChats } from "../chatJump";
 *   showChats({ ad: row.ad_id });          // or { product: "cereal" }
 *
 * It goes to 对话 by the address (#leads), as back and a typed address do, so the caller needs nothing from App.
 * 对话 is mounted from the start and hears it at once; one mounted later takes it when it starts (takeChatJump).
 */
export interface ChatJump {
  /** The ad's id (identity ad_id), as /report/ads rows carry it. */
  ad?: string;
  /** A product as 经营 keys it: cereal, zenite, detox, meal, other. */
  product?: string;
}

export const CHAT_JUMP = "leads:show";

let pending: ChatJump | null = null;

export function showChats(jump: ChatJump): void {
  pending = jump;
  window.dispatchEvent(new CustomEvent<ChatJump>(CHAT_JUMP, { detail: jump }));
  if (window.location.hash !== "#leads") window.location.hash = "leads";
}

/** The jump nobody has taken yet, once. */
export function takeChatJump(): ChatJump | null {
  const j = pending;
  pending = null;
  return j;
}
